import React from "react";
import type { Position } from "@foundation/watchlist-client";
import styles from "./styles.module.css";
import { PortfolioColumnConfig, PortfolioLot } from "~types/portfolio";
import TickerEntry from "~components/Portfolio/PortfolioTable/Entry/TickerEntry";
import LotsEntry from "~components/Portfolio/PortfolioTable/Entry/LotsEntry";
import { ROW_TYPES } from "~constants/Portfolio";

const { TICKER } = ROW_TYPES;

type PortfolioRowProps = {
  columnsConfig: Array<PortfolioColumnConfig>;
  rowType?: string;
  watchlistRow: Position | PortfolioLot;
};

export default function PortfolioRow(props: PortfolioRowProps) {
  const { watchlistRow, columnsConfig, rowType = TICKER } = props;
  const generateRowOfEntries = () => {
    return columnsConfig.map((columnConfig) => {
      if (rowType === TICKER) {
        return (
          <TickerEntry
            key={`${(watchlistRow as Position).security.ticker}-${
              columnConfig.columnName
            }`}
            ticker={watchlistRow as Position}
            {...columnConfig}
          />
        );
      }

      return (
        <LotsEntry
          key={`lot${(watchlistRow as PortfolioLot).lotId}-${
            columnConfig.columnName
          }`}
          lot={watchlistRow as PortfolioLot}
          {...columnConfig}
        />
      );
    });
  };

  if (rowType !== TICKER && watchlistRow.shares.number === 0) {
    return null;
  }

  return (
    <div className={styles.row} role="row">
      {generateRowOfEntries()}
    </div>
  );
}
